const wishlistEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 67.949 67.949" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M62.49 11.239c-7.39-7.388-19.412-7.388-26.8 0l-1.716 1.715-1.715-1.715c-7.388-7.389-19.411-7.389-26.799 0-7.238 7.238-7.285 18.711-.109 26.688 6.545 7.273 25.848 22.986 26.667 23.651a2.986 2.986 0 0 0 1.89.672l.065-.001c.688.032 1.381-.204 1.955-.671.819-.665 20.124-16.378 26.671-23.652 7.175-7.976 7.128-19.449-.109-26.687zm-4.351 22.674c-5.103 5.669-19.13 17.361-24.166 21.51-5.036-4.148-19.06-15.839-24.162-21.509-5.006-5.564-5.053-13.488-.109-18.432 2.525-2.524 5.841-3.787 9.157-3.787s6.632 1.262 9.157 3.787l3.772 3.772a2.902 2.902 0 0 0 1.609.811 3.006 3.006 0 0 0 2.76-.81l3.774-3.773c5.051-5.049 13.267-5.048 18.315 0 4.944 4.944 4.897 12.868-.107 18.431z" fill="#548091" opacity="1" data-original="#000000" class=""></path></g></svg>'
  , wishlistFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M471.383 44.578C444.879 15.832 408.512 0 368.973 0c-29.555 0-56.621 9.344-80.45 27.77C276.5 37.07 265.605 48.45 256 61.73c-9.602-13.277-20.5-24.66-32.527-33.96C199.648 9.344 172.582 0 143.027 0c-39.539 0-75.91 15.832-102.414 44.578C14.426 72.988 0 111.801 0 153.871c0 43.3 16.137 82.938 50.781 124.742 30.992 37.395 75.535 75.356 127.117 119.313 17.614 15.012 37.579 32.027 58.309 50.152A30.023 30.023 0 0 0 256 455.516c7.285 0 14.316-2.641 19.785-7.43 20.73-18.129 40.707-35.152 58.328-50.172 51.575-43.95 96.117-81.906 127.11-119.305C495.867 236.81 512 197.172 512 153.867c0-42.066-14.426-80.879-40.617-109.289zm0 0" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>'
  , wishlistPopupCloseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.00006 7.00007L16 0L18 2L11 9.00006L18 16L16 18L9.00006 11L2 18L0 16L7.00007 9.00006L0 2L2 0L9.00006 7.00007Z" fill="#161616"/></svg>'
  , wishlistDeleteIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M1871 5109 c-128 -25 -257 -125 -311 -241 -37 -79 -50 -146 -50 -259 l0 -89 -389 0 c-222 0 -411 -4 -442 -10 -187 -36 -330 -184 -361 -376 -30 -181 66 -371 231 -458 l69 -36 6 -58 c4 -31 65 -763 136 -1627 72 -863 134 -1587 139 -1608 36 -155 177 -295 335 -332 91 -22 2561 -22 2652 0 158 37 299 177 335 332 5 21 67 745 139 1608 71 864 132 1596 136 1627 l6 58 69 36 c165 87 261 277 231 458 -31 192 -174 340 -361 376 -31 6 -220 10 -442 10 l-389 0 0 89 c0 48 -5 112 -10 142 -34 180 -179 325 -359 359 -66 12 -1306 12 -1370 -1z m1359 -309 c60 -31 80 -78 80 -190 l0 -90 -750 0 -750 0 0 90 c0 110 20 159 78 189 36 19 60 20 670 21 615 0 634 -1 672 -20z m1200 -600 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -39 -20 -55 -20 -1870 -20 -1815 0 -1831 0 -1870 20 -45 23 -80 80 -80 130 0 48 35 107 78 129 36 20 65 20 1870 21 1818 0 1833 0 1872 -20z m-236 -622 c-2 -24 -63 -747 -134 -1606 -140 -1694 -129 -1598 -193 -1646 l-28 -21 -1279 0 -1279 0 -28 21 c-64 48 -53 -48 -193 1646 -71 859 -132 1582 -134 1606 l-6 42 1640 0 1640 0 -6 -42z"></path><path d="M1587 3299 c-25 -13 -45 -34 -58 -62 l-21 -43 76 -1234 c85 -1381 76 -1299 155 -1340 51 -25 91 -25 142 0 27 14 46 34 60 63 l21 43 -76 1234 c-85 1381 -76 1299 -155 1340 -50 25 -95 25 -144 -1z"></path><path d="M2488 3299 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -57 -20 -1280 0 -1224 0 -1241 20 -1280 23 -45 80 -80 130 -80 50 0 107 35 130 80 20 39 20 56 20 1280 0 1224 0 1241 -20 1280 -37 73 -127 99 -202 59z"></path><path d="M3387 3299 c-77 -41 -68 37 -153 -1339 l-76 -1234 21 -43 c14 -29 33 -49 60 -63 51 -25 91 -25 142 0 79 41 70 -41 155 1340 l76 1234 -21 43 c-37 75 -127 103 -204 62z"></path></g></svg>'
  , wishlistLikeEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 478.2 478.2" style="" xml:space="preserve" class=""><g><path d="M457.575 325.1c9.8-12.5 14.5-25.9 13.9-39.7-.6-15.2-7.4-27.1-13-34.4 6.5-16.2 9-41.7-12.7-61.5-15.9-14.5-42.9-21-80.3-19.2-26.3 1.2-48.3 6.1-49.2 6.3h-.1c-5 .9-10.3 2-15.7 3.2-.4-6.4.7-22.3 12.5-58.1 14-42.6 13.2-75.2-2.6-97-16.6-22.9-43.1-24.7-50.9-24.7-7.5 0-14.4 3.1-19.3 8.8-11.1 12.9-9.8 36.7-8.4 47.7-13.2 35.4-50.2 122.2-81.5 146.3-.6.4-1.1.9-1.6 1.4-9.2 9.7-15.4 20.2-19.6 29.4-5.9-3.2-12.6-5-19.8-5h-61c-23 0-41.6 18.7-41.6 41.6v162.5c0 23 18.7 41.6 41.6 41.6h61c8.9 0 17.2-2.8 24-7.6l23.5 2.8c3.6.5 67.6 8.6 133.3 7.3 11.9.9 23.1 1.4 33.5 1.4 17.9 0 33.5-1.4 46.5-4.2 30.6-6.5 51.5-19.5 62.1-38.6 8.1-14.6 8.1-29.1 6.8-38.3 19.9-18 23.4-37.9 22.7-51.9-.4-8.1-2.2-15-4.1-20.1zm-409.3 122.2c-8.1 0-14.6-6.6-14.6-14.6V270.1c0-8.1 6.6-14.6 14.6-14.6h61c8.1 0 14.6 6.6 14.6 14.6v162.5c0 8.1-6.6 14.6-14.6 14.6h-61v.1zm383.7-133.9c-4.2 4.4-5 11.1-1.8 16.3 0 .1 4.1 7.1 4.6 16.7.7 13.1-5.6 24.7-18.8 34.6-4.7 3.6-6.6 9.8-4.6 15.4 0 .1 4.3 13.3-2.7 25.8-6.7 12-21.6 20.6-44.2 25.4-18.1 3.9-42.7 4.6-72.9 2.2h-1.4c-64.3 1.4-129.3-7-130-7.1h-.1l-10.1-1.2c.6-2.8.9-5.8.9-8.8V270.1c0-4.3-.7-8.5-1.9-12.4 1.8-6.7 6.8-21.6 18.6-34.3 44.9-35.6 88.8-155.7 90.7-160.9.8-2.1 1-4.4.6-6.7-1.7-11.2-1.1-24.9 1.3-29 5.3.1 19.6 1.6 28.2 13.5 10.2 14.1 9.8 39.3-1.2 72.7-16.8 50.9-18.2 77.7-4.9 89.5 6.6 5.9 15.4 6.2 21.8 3.9 6.1-1.4 11.9-2.6 17.4-3.5.4-.1.9-.2 1.3-.3 30.7-6.7 85.7-10.8 104.8 6.6 16.2 14.8 4.7 34.4 3.4 36.5-3.7 5.6-2.6 12.9 2.4 17.4.1.1 10.6 10 11.1 23.3.4 8.9-3.8 18-12.5 27z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>'
  , wishlistLikeFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.999 511.999" style="" xml:space="preserve" class=""><g><path d="M15.34 224.948c-8.365 0-15.146 6.782-15.146 15.146v222.458c0 8.365 6.782 15.146 15.146 15.146h91.253v-252.75H15.34zM511.805 308.587c0-19.227-10.331-36.087-25.733-45.321a52.504 52.504 0 0 0 9.362-29.985c0-29.113-23.686-52.799-52.799-52.799H331.177c3.416-15.48 8.088-38.709 11.341-63.026 8.466-63.281 2.68-98.376-18.207-110.445-13.022-7.523-27.062-9.049-39.534-4.301-9.635 3.67-22.647 12.693-30.062 34.838l-29.294 76.701c-14.851 36.677-60.33 75.182-88.535 96.473V484.4C189.16 502.716 243.708 512 299.358 512h121.446c29.113 0 52.799-23.686 52.799-52.799a52.481 52.481 0 0 0-7.93-27.804c17.601-8.572 29.759-26.646 29.759-47.503a52.504 52.504 0 0 0-9.362-29.985c15.404-9.234 25.735-26.095 25.735-45.322z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>'
  , setCookie = (cname,cValue,exDays)=>{
    var d = new Date;
    d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1e3);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cValue + ";" + expires + ";path=/"
}
  , techno_getCookie = cname=>{
    for (var name = cname + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
        for (var c = ca[i]; c.charAt(0) == " "; )
            c = c.substring(1);
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length)
    }
    return ""
}
  , getMainButtonClass = buttonSty=>{
    let btnClass = "";
    return buttonSty && (buttonSty == 1 ? btnClass = "tt-icon-border" : buttonSty == 2 ? btnClass = "tt-border" : buttonSty == 3 ? btnClass = "tt-icon-fill" : buttonSty == 4 ? btnClass = "tt-fill" : buttonSty == 5 ? btnClass = "tt-icon-text" : buttonSty == 6 ? btnClass = "tt-text" : buttonSty == 7 && (btnClass = "tt-only-icon")),
    btnClass
}
  , formatMoney = (t,e=window.money_format)=>{
    function o(t2, e2) {
        return t2 === void 0 ? e2 : t2
    }
    function i(t2, e2, i2, r2) {
        if (e2 = o(e2, 2),
        i2 = o(i2, ","),
        r2 = o(r2, "."),
        isNaN(t2) || t2 == null)
            return 0;
        t2 = (t2 / 100).toFixed(e2);
        var n2 = t2.split(".");
        return n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i2) + (n2[1] ? r2 + n2[1] : "")
    }
    typeof t == "string" && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || "\u20B9 {{amount}}";
    switch (a.match(n)[1]) {
    case "amount":
        r = i(t, 2);
        break;
    case "amount_no_decimals":
        r = i(t, 0);
        break;
    case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        r = i(t, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        r = i(t, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        r = i(t, 0, " ");
        break;
    case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".")
    }
    return a.replace(n, r)
}
  , showToastMsg = async(handle,isLocal=!1)=>{
    let notificationSetting = window.wishlistMetafields.notification_setting
      , notificationEnable = window.wishlistMetafields.show_notification_popup
      , toastDuration = notificationSetting.duration
      , className = notificationSetting.notificationPlacement
      , brandEnable = notificationSetting.enableBranding
      , brandText = notificationSetting.brandText;
    if (notificationEnable == 0)
        return !1;
    let product = await fetch(`/products/${handle}.js`);
    product = await product.json();
    let content = {
        src: product.featured_image,
        title: product.title
    }
      , divEle = document.createElement("DIV");
    divEle.setAttribute("class", `wishlist-toast-msg-wrap tt-position ${className}`);
    let brandHtml = "";
    brandEnable == 1 && (brandHtml = `
            <p class="wishlist-branding-wrap wishlist-p-tag">${brandText}</p>
        `);
    let msg = `<strong>${content.title}</strong> ${window.success_mnessage_popup}`;
    isLocal && window.wishlistMsgWithoutCategory && (msg = window.wishlistMsgWithoutCategory,
    msg = msg.replace("##", content.title)),
    !isLocal && window.wishlistMsgWithCategory && (msg = window.wishlistMsgWithoutCategory,
    msg.replace("##", content.title),
    msg = msg.replace("$$", content.listName)),
    divEle.innerHTML = `
        <div class="wishlist-toast-msg">
            <div class="left-side-img">
                <img src=${content.src} alt=${content.title} />
            </div>
            <div class="right-side-content">
                <p class="wishlist-product-toast-msg wishlist-p-tag">${msg}</p>
                ${brandHtml}
            </div>
        </div>
    `,
    document.body.append(divEle),
    setTimeout(()=>{
        document.querySelectorAll(".wishlist-toast-msg-wrap").forEach(ele=>{
            ele.remove()
        }
        )
    }
    , Number(toastDuration) * 1e3)
}
  , wishlistPopupOpen = (flag=!1)=>{
    let module = window.wishlistMetafields.button_setting.wishlist_module
      , popupWrap = document.querySelector(".tt-wishlist-details-popup");
    module == "drawer" && popupWrap.classList.add("drawer"),
    flag ? (popupWrap.classList.remove("active"),
    document.body.classList.remove("tt-overflow-hidden")) : (popupWrap.classList.add("active"),
    document.body.classList.add("tt-overflow-hidden"))
}
  , setWishlistAPIData = async()=>{
    let module = window.wishlistMetafields.button_setting.wishlist_module
      , category_enable = window.wishlistMetafields.category_enable
      , empty_wishlist = window.wishlistMetafields.language2.empty_wishlist
      , fontSizeMultipler = 1;
    module == "page" && (fontSizeMultipler = .75);
    let mainWrap = document.querySelector(".tt-wishlist-details-main")
      , cartMainWrap = document.querySelector(".tt-wishlist-save-for-later");
    mainWrap.setAttribute("style", `--tt-wishlist-font-multipler:${fontSizeMultipler};`);
    let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
    let cartContentWrap = null;
    if(cartMainWrap){
        cartMainWrap.setAttribute('style',`--tt-wishlist-font-multipler:${fontSizeMultipler};`);
        cartContentWrap = cartMainWrap.querySelector(".tt-wishlist-details-content");

    }
     let tabHeader = ""
      , tabContent = ""
      , count = 0
      , categoriesDetails = await getCategoriesDetailsApi();
    if (categoriesDetails.status == 200)
        if (categoriesDetails.data && categoriesDetails.data.length > 0) {
            let saveCategory = {
                ...categoriesDetails
            }.data.find(item=>item.category_name == "Save for later");
            categoriesDetails.data = categoriesDetails.data.filter(category=>category.category_name !== "Save for later");
            let newCategory = categoriesDetails.data;
            if (newCategory = newCategory.filter(category=>category.category_name !== "Save for later"),
            !category_enable && window.customerExist && categoriesDetails.data.forEach((category,index)=>{
                index != 0 && (newCategory[0].details = newCategory[0].details.concat(category.details),
                category.details = [])
            }
            ),
            newCategory.forEach((category,index)=>{
                let categoryRemoveBtn = `
                    <button type="button" class="tt-category-remove" data-cid="${category.category_id}">
                        ${wishlistDeleteIcon}
                    </button>
                `;
                window.isWishlistSharedPage && (categoryRemoveBtn = ""),
                tabHeader += `
                    <li class="${index == 0 ? "active" : ""}" data-tab="tab${index}">
                        <button type="button" class="tt-tab-title" data-tab="tab${index}">${category.category_name}</button>
                        ${categoryRemoveBtn}
                    </li>
                `;
                let productList = "";
                category.details.forEach(product=>{
                    count++,
                    productList += `
                        <div class="tt-product-list product-grid-item" data-id="${product.product_id}" data-handle="${product.handle}">
                        </div>
                    `
                  }
                ),
                productList == "" && (productList = `<p style="text-align:center;">
                        ${empty_wishlist}
                    </p>`),
                tabContent += `
                    <div class="${index == 0 ? "active" : ""} tab-content-inner-wrap" data-tab="tab${index}">
                        ${productList}
                    </div>
                `
            }
            ),
            contentWrap && (contentWrap.innerHTML = `
                <ul class="tt-tab-header-wrap">${tabHeader}</ul>
                <div class="tt-tab-content-wrap">${tabContent}</div>
            `),
            saveCategory != undefined && saveCategory.details.length > 0) {
                let saveProductList = "";
                saveCategory.details.forEach(product=>{
                    saveProductList += `
                        <div class="tt-product-list tt-sfl" data-handle="${product.handle}">
                        </div>
                    `
                }
                );
                if(cartContentWrap != null)
                cartContentWrap.innerHTML = `
                      <div class="tt-wishlist-details-main save_for_later_cat">
                    <ul class="tt-tab-header-wrap">
                    <li class="active">
                            <button type="button" class="tt-tab-title" >Save for later</button>
                        </li>
                    </ul>
                    <div class="tt-tab-content-wrap"><div class="tab-content-inner-wrap active">${saveProductList}</div>
                    </div>
                    </div>
                `
            } else
               if(cartContentWrap != null)
                cartContentWrap.innerHTML = "";
            updateProductContent()
        } else
            contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `;
    else
        contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `;
    if (!category_enable && window.customerExist) {
        let tabHeaderEle = document.querySelectorAll(".tt-tab-header-wrap");
        tabHeaderEle && tabHeaderEle.forEach(item=>{
            item.closest(".tt-wishlist-save-for-later") || item.classList.add("tt-hide")
        }
        )
    }
    wishlistUpdateCount(count)
}
  , setWishlistLocalData = async flag=>{
    let module = window.wishlistMetafields.button_setting.wishlist_module
      , empty_wishlist = window.wishlistMetafields.language2.empty_wishlist
      , fontSizeMultipler = 1;
    module == "page" && (fontSizeMultipler = .75);
    let count = 0
      , mainWrap = document.querySelector(".tt-wishlist-details-main");
    mainWrap.setAttribute("style", `--tt-wishlist-font-multipler:${fontSizeMultipler};`);
    let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content")
      , tabContent = ""
      , productsData = techno_getCookie("wishlist");
    productsData ? (productsData = JSON.parse(productsData),
    productsData && productsData.length > 0 ? (productsData.forEach((product,index)=>{
        count++,
        tabContent += `
                    <div class="tt-product-list" data-handle="${product.p_handle}">
                    </div>
                `
    }
    ),
    tabContent == "" && (tabContent = `<p style="text-align:center;">
                    ${empty_wishlist}
                </p>`),
    contentWrap.innerHTML = `
                <div class="tt-tab-content-wrap">
                    <div class="active tab-content-inner-wrap" data-tab="tab0">
                        ${tabContent}
                    </div>
                </div>
            `,
    updateProductContent()) : contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `) : contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `,
    flag && (contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `),
    wishlistUpdateCount(count)
}
  , wishlistUpdateCount = count=>{
    let countWrap = document.querySelector(".wishlist-total-count");
    if(count < 1){
      document.querySelectorAll('.wishlist-total-count').forEach(function(e) {
        e.style.display = "none";   
      })
    }else{
        document.querySelectorAll('.wishlist-total-count').forEach(function(e) {
          e.style.display = "flex";   
          e.innerHTML = count;
        })  
    };
    countWrap && (count || (count = 0),
    countWrap.innerHTML = count)
}
  , wishlistContent = ()=>{
    this.customerExist ? setWishlistAPIData() : window.wishlistMetafields.guest_wishlist == 1 ? setWishlistLocalData() : setWishlistLocalData(!0)
}
  , updateProductContent = (flag=!1,isTrending)=>{
    let allProductArr = [];
    document.querySelectorAll(".tt-product-list").forEach(ele=>{
        isTrending ? allProductArr.push(ele) : ele.closest(".tt-wishlist-trending-wrap") || allProductArr.push(ele)
    }
    ),
    fetchProductDetails(allProductArr, flag)
}
  , fetchProductDetails = async(products,flag)=>{
          setTimeout(function(e) {

            var newheight = 0;
            $('.new_min_height').css('height','');
            $('.new_min_height').each(function(e) {
                if(newheight < $(this).innerHeight()){
                    newheight = $(this).innerHeight();
                } 
            })
            $('.new_min_height').css('height',newheight+'px');
            
            
            var height = 0;
            $('.tt-product-content').css('height','');
            $('.tt-product-content').each(function(e) {
                if(height < $(this).innerHeight()){
                    height = $(this).innerHeight();
                } 
            })
            $('.tt-product-content').css('height',height+'px');
            
          },500);
    if (products && products.length > 0) {
        let language2 = window.wishlistMetafields.language2
          , atcText = window.move_to_cart_text
          , oosText = language2.btn_oos_text
          , atcColor = language2.btn_text_color
          , oosColor = language2.oos_text_color
          , atcColorBg = language2.btn_bg_color
          , oosColorBg = language2.oos_bg_color
          , currenrProduct = products.pop()
          , pHandle = currenrProduct.getAttribute("data-handle"),
          pid = currenrProduct.getAttribute("data-id");;
        currenrProduct.setAttribute("style", `--tt-atc-btn-color:${atcColor}; --tt-atc-btn-bg:${atcColorBg}; --tt-oos-btn-color:${oosColor}; --tt-oos-btn-bg:${oosColorBg};`);
        let product = await fetch(`/products/${pHandle}.js`);
        if(product.status == 200){
            product = await product.json();
            let variantHtml = '';
            let defaultVariant = false;
            let atcButton = true;
            if(!product.available){
                atcButton = false;
                defaultVariant = true;
            }
            // if(product.available){
                product.variants.forEach((variant,index)=>{
                    if(variant.title == 'Default Title'){
                        defaultVariant = true;
                        if(!variant.available){
                            atcButton = false;
                        }
                    }
                    if(window.wishlistMetafields.enable_variants == 0){
                        defaultVariant = true;
                    }
                    variantHtml += `
                        <option value="${variant.id}" data-price="${variant.price}" data-available=${variant.available} ${variant.available ? '': 'disabled'}>${variant.title}</option>
                    `;
                });
            // }
            var ctm_variant = $('.ctm_product_swatch[data-id="'+product.id+'"]').html();
           console.log(ctm_variant,'ctm_variants.....')
            if(ctm_variant == undefined){
              ctm_variant = '';
            }
            let atcButtonHtml = "";
            atcButton ? (atcButtonHtml = `
                    <button type="button" class="tt-product-atc-main" data-id=${product.id}>
                        ${atcText}
                    </button>
                `,
            window.wishlistMetafields.show_add_to_cart_btn == 0 && (atcButtonHtml = "")) : (atcButtonHtml = `
                    <button type="button" class="tt-product-atc-main" disabled data-id=${product.id}>
                        ${oosText}
                    </button>
                `,
            window.wishlistMetafields.show_oos_btn == 0 && (atcButtonHtml = ""));
            let qtyHtml = '<input class="tt-qty-input" name="tt-quantity" type="hidden" value=1 >';
            window.wishlistMetafields.qty_enable == 1 && (qtyHtml = `
                <div class="tt-qty-input">
                    <p class="tt-qty-label">Quantity</p>
                    <div class="tt-qty-input-inner">
                        <button class="tt-qty-count tt-qty-count--minus" data-action="minus" type="button">-</button>
                        <input class="tt-product-qty" type="number" name="tt-quantity" min="1" value="1">
                        <button class="tt-qty-count tt-qty-count--add" data-action="add" type="button">+</button>
                    </div>
                </div>
                `);
            let vendorHtml = "";
            var local = '';  
            if(Shopify.locale != 'en'){
              local = '/'+Shopify.locale;
            }  
            window.wishlistMetafields.show_vendor_name == 1 && (vendorHtml = `
                    <div class="tt-product-vendor-text grid-product__vendor cstm_product_vendor">
                       <a href="${local}/collections/vendors?q=${product.vendor}"> ${product.vendor}</a>
                    </div>
                `);
            let productRemoveBtn = `
                <div class="tt-product-remove-wishlist" data-id=${product.id}>
                    ${wishlistPopupCloseIcon}
                </div>
            `;
            var msrp = $('.ctm_msrp_price .msrp_product[data-id="'+product.id+'"]').html();
            if(msrp == null || msrp == undefined){
              msrp = ''
            }
            window.isWishlistSharedPage && (productRemoveBtn = "");
            var second_html = ''
            if(product.media.length > 1){
              second_html = `<div class="grid-product__secondary-image small--hide">
                 <image-element data-image-type="">
                 <img src="${product.media[1].src}" alt="" loading="lazy" class="image-style--square image-element animape animape-visible" data-animape="fadein">    
                </image-element>`;
            }
            var locale = '/'+Shopify.locale;
            if(Shopify.locale == 'en'){
              locale = '';
            }
            let productHtml = `
            <div class="image_wrapper">
            <a href="${window.origin}${locale}${product.url}" class="grid-item__link">
            <div class="grid-product__image-wrap">
              <div class="grid__image-ratio grid__image-ratio--square">
                <image-element data-image-type="">
                 <img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="image-style--square image-element animape animape-visible" data-animape="fadein">  
                </image-element>
                ${second_html}
              </div>
            </div>
            </div>
            </a>
                <a href="${window.origin}${locale}${product.url}" class="tt-image-a" style="display:none">
                    <div class="tt-image-wrap">
                        <img src="${product.featured_image}" alt="${product.title}" />
                    </div>
                </a>
                </div>
                <div class="tt-product-content grid-item__meta">
                  <div class="grid-item__meta-main new_min_height  vendor_swatch_space">
                    <a href="${window.origin}${locale}${Shopify.locale}${product.url}" class="grid-product__title cstm_product_title">
                        ${product.title}
                    </a>
                       ${vendorHtml}
                       ${ctm_variant}
                   </div>
                  <div class="block-price__container" data-on-sale="">
                    <div class="block-price__sale product__price">
                    ${msrp}
                       <span class="product__price">
                        <span aria-hidden="true">
                        <div class="tt-product-price-wrap">
                          ${formatMoney(product.variants[0].price)}
                        </div>
                       </span>
                      </span>
                      
                    </div>
                    </div>
                    <select class="${defaultVariant ? "tt-hide" : ""}">
                        ${variantHtml}
                    </select>
                    
                    <div class="tt-qty-selector">
                        ${qtyHtml}
                    </div>
                </div>
                <div class='tt-error-msg'></div>
                <div class="tt-product-action">
                    <div class="tt-atc-button-wrap">
                        ${atcButtonHtml}
                    </div>
                    ${productRemoveBtn}
                </div>
            `;
            currenrProduct.innerHTML = productHtml,
            fetchProductDetails(products, flag) 
        }else{
          if(pHandle != undefined){
           // document.querySelector('.tt-product-list[data-handle='+pHandle+']').remove();   
            let productRemoveBtn = `
                <div class="tt-product-remove-wishlist" data-id=${pid}>
                    ${wishlistPopupCloseIcon}
                </div>
              `;
            var html = ` <div class="tt-product-action">
                      ${productRemoveBtn}
                  </div>`;
            currenrProduct.innerHTML = html;
            fetchProductDetails(products, flag);
            window.ttWishlistClickEvents();
            document.querySelector('.tt-product-list[data-handle="'+pHandle+'"] .tt-product-remove-wishlist').click();
          }

        }
    } else if (window.ttWishlistClickEvents(),
    flag) {
        let allTrendingEle = document.querySelectorAll(".super-wishlist-trending-widget .swiper");
        if (allTrendingEle.length > 0) {
            let firstParent = allTrendingEle[0].closest(".super-wishlist-trending-widget")
              , slideDesk = Number(firstParent.getAttribute("data-desktop-row"))
              , slideMob = Number(firstParent.getAttribute("data-mobile-row"))
              , slideArrow = firstParent.getAttribute("data-arrow")
              , slideAuto = firstParent.getAttribute("data-auto-rotate")
              , sliderSettings = {
                slidesPerView: slideMob,
                loop: !1,
                breakpoints: {
                    300: {
                        slidesPerView: slideMob
                    },
                    767: {
                        slidesPerView: slideDesk
                    }
                }
            };
            slideAuto && (sliderSettings.autoplay = {
                delay: 4e3
            }),
            allTrendingEle.forEach(ele=>{
                let mainParent = ele.closest(".super-wishlist-trending-widget");
                mainParent.style.opacity = 1,
                slideArrow && (sliderSettings.navigation = {
                    nextEl: ele.querySelector(".swiper-button-next"),
                    prevEl: ele.querySelector(".swiper-button-prev")
                }),
                new Swiper(ele,sliderSettings)
            }
            )
        }
    }
}
  , getCategoriesApi = async()=>{
    let url = window.wishlistUrl + "get/all?customer_id=" + window.customerId
      , getCategories = await fetch(url, {
        method: "GET",
        headers: {
            shop: window.shop_domin
        }
    });
    return getCategories = await getCategories.json(),
    window.getCategoriesData = getCategories,
    getCategories
}
  , getCategoriesDetailsApi = async()=>{
    let url = window.wishlistUrl + "get/product-details?customer_id=" + window.customerId
      , getCategories = await fetch(url, {
        method: "GET",
        headers: {
            shop: window.shop_domin
        }
    });
    return getCategories = await getCategories.json(),
    getCategories
}
  , addProductInCategoryApi = async(catId,id)=>{
    let data = {
        customer_id: window.customerId,
        category_id: catId,
        product_id: id
    }
      , addTowish = await fetch(window.wishlistUrl + "category/product-add", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return addTowish = await addTowish.json(),
    addTowish
}
  , removeProductApi = async id=>{
    let data = {
        customer_id: window.customerId,
        product_id: id
    }
      , removeProduct = await fetch(window.wishlistUrl + "category/product-delete", {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return removeProduct = await removeProduct.json(),
    removeProduct
}
  , removeCategoryApi = async id=>{
    let data = {
        customer_id: window.customerId,
        category_id: id
    }
      , removeCategory = await fetch(window.wishlistUrl + "category/delete", {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return removeCategory = await removeCategory.json(),
    removeCategory
}
  , createCategoryApi = async catName=>{
    let data = {
        customer_id: window.customerId,
        category_name: catName,
        customer_email: window.customerEmail,
        customer_name: window.customerName
    }
      , createCat = await fetch(window.wishlistUrl + "category/create-update", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return createCat = await createCat.json(),
    createCat
}
  , cartCountApi = async()=>{
    let url = window.wishlistUrl + "analytics"
      , data = {
        cart_count: 1
    }
      , cartCount = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return cartCount = await cartCount.json(),
    cartCount
}
  , pageCountApi = async()=>{
    let url = window.wishlistUrl + "analytics"
      , data = {
        page_count: 1
    }
      , pageCount = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return pageCount = await pageCount.json(),
    pageCount
}
  , submitVoteApi = async(pId,flag)=>{
    let url = window.wishlistUrl + "product-vote"
      , data = {
        customer_id: window.customerId,
        product_id: pId,
        vote_count: flag ? 1 : 0
    }
      , voteData = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            shop: window.shop_domin
        },
        body: JSON.stringify(data)
    });
    return voteData = await voteData.json(),
    voteData
}
  , getVoteDataApi = async pId=>{
    let url = window.wishlistUrl + "product-vote?product_id=" + pId
      , getVoteData = await fetch(url, {
        method: "GET",
        headers: {
            shop: window.shop_domin
        }
    });
    return getVoteData = await getVoteData.json(),
    getVoteData
}
  , getCustomerVoteDataApi = async pId=>{
    let url = window.wishlistUrl + "product-vote?product_id=" + pId + "&customer_id=" + window.customerId
      , getVoteData = await fetch(url, {
        method: "GET",
        headers: {
            shop: window.shop_domin
        }
    });
    return getVoteData = await getVoteData.json(),
    getVoteData
}
  , trendingApi = async()=>{
    let url = window.wishlistUrl + "trending-wishlist"
      , trendingData = await fetch(url, {
        method: "GET",
        headers: {
            shop: window.shop_domin
        }
    });
    return trendingData = await trendingData.json(),
    trendingData
}
  , removeFromCartApi = async = id=>{
    let updates = {};
    updates[id] = 0,
    fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            updates
        })
    }).then(response=>response.json()).then(res=>{
        window.location.reload()
    }
    ).catch(error=>{
        console.error("Error:", error)
    }
    )
}
  , ajaxAddtocart = async items=>{
    let add = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            items
        })
    });
    return add = await add.json(),
    add
}
;
class WishlistPDP {
    constructor() {
        if (this.storeId = window.shop_domin,
        this.wishlistMeta = window.wishlistMetafields,
        this.customerExist = window.customerExist,
        this.customerName = window.customerName,
        this.customerEmail = window.customerEmail,
        this.wishlistUrl = window.wishlistUrl,
        this.wishlistPageUrl = Shopify.locale+"/apps/wishlist/wishlist-landing",
        window.isWishlistSharedPage = !1,
        this.customerExist && (this.customerId = window.customerId),
        !this.customerExist) {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.has("q") && window.location.pathname.includes("wishlist-share") && (window.isWishlistSharedPage = !0,
            this.customerExist = !0,
            window.customerExist = !0,
            this.customerId = Number(searchParams.get("q")),
            window.customerId = this.customerId)
        }
        this.init(),
        (this.wishlistMeta.show_trending_wishlist == "1" || this.wishlistMeta.show_trending_wishlist == 1) && this.trendingWishlistSetup(),
        document.addEventListener("click", e=>{
            e.target && (e.target.classList.length > 0 && e.target.classList.contains("tt-wishlist-plp-btn-main") ? this.plpButtonClick(e) : e.target.closest(".tt-wishlist-plp-btn-main") && this.plpButtonClick(e.target.closest(".tt-wishlist-plp-btn-main")))
        }
        )
    }
    clickEvents = ()=>{
        let wishlist_btn = document.querySelectorAll(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap");
        wishlist_btn.length > 0 && wishlist_btn.forEach(item=>{
            item.removeEventListener("click", this.pdpButtonClick),
            item.addEventListener("click", this.pdpButtonClick)
        }
        );
        let categoryPopupClose = document.querySelector(".wishlist-create-category-popup .tt-category-close");
        categoryPopupClose && (categoryPopupClose.removeEventListener("click", this.categoryPopupShow),
        categoryPopupClose.addEventListener("click", ()=>this.categoryPopupShow(!0))),
        document.querySelectorAll(".wishlist-create-category-popup .tt-form-group .tt-add-wishlist").forEach(ele=>{
            ele.removeEventListener("click", this.addProductInCategory),
            ele.addEventListener("click", this.addProductInCategory)
        }
        );
        let createCategory = document.querySelector(".wishlist-create-category-popup .tt-form-new-group .tt-add-wishlist");
        createCategory && (createCategory.removeEventListener("click", this.createCategoryEvent),
        createCategory.addEventListener("click", this.createCategoryEvent)),
        [".wishlist-floting-btn-wrap", ".wishlist-page-widget"].forEach(btnClass=>{
            document.querySelectorAll(btnClass).forEach(ele=>{
                ele.removeEventListener("click", this.wishlistBtnEvent),
                ele.addEventListener("click", this.wishlistBtnEvent)
            }
            )
        }
        ),
        document.querySelectorAll(".tt-tab-header-wrap .tt-tab-title").forEach(ele=>{
            ele.removeEventListener("click", this.tabChangeEvent),
            ele.addEventListener("click", this.tabChangeEvent)
        }
        );
        let detailsPopupClose = document.querySelector(".tt-wishlist-details-popup .tt-details-close");
        detailsPopupClose && (detailsPopupClose.removeEventListener("click", this.detailsPopupCloseEvent),
        detailsPopupClose.addEventListener("click", this.detailsPopupCloseEvent));
        let detailsPopupOverlay = document.querySelector(".tt-wishlist-details-popup .tt-popup-overlay");
        detailsPopupOverlay && (detailsPopupOverlay.removeEventListener("click", this.detailsPopupCloseEvent),
        detailsPopupOverlay.addEventListener("click", this.detailsPopupCloseEvent));
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        shareButton && (shareButton.removeEventListener("click", this.shareButtonEvent),
        shareButton.addEventListener("click", e=>this.shareButtonEvent()));
        let sharePopupClose = document.querySelector(".tt-share-wishlist-popup .tt-share-wishlist-close");
        sharePopupClose && (sharePopupClose.removeEventListener("click", this.shareButtonEvent),
        sharePopupClose.addEventListener("click", e=>this.shareButtonEvent(!0)));
        let sharePopupOverlay = document.querySelector(".tt-share-wishlist-popup .tt-popup-overlay");
        sharePopupOverlay && (sharePopupOverlay.removeEventListener("click", this.shareButtonEvent),
        sharePopupOverlay.addEventListener("click", e=>this.shareButtonEvent(!0))),
        document.querySelectorAll(".tt-wishlist-details-main .tt-category-remove").forEach(ele=>{
            ele.removeEventListener("click", this.removeCategoryEvent),
            ele.addEventListener("click", e=>{
                let that = e.currentTarget;
                this.removeCategoryEvent(that)
            }
            )
        }
        ),
        document.querySelectorAll(".tt-wishlist-details-main .tt-product-remove-wishlist").forEach(ele=>{
            ele.removeEventListener("click", this.removeProductEvent),
            ele.addEventListener("click", e=>{
                let that = e.currentTarget;
                this.removeProductEvent(that)
            }
            )
        }
        ),
        document.querySelectorAll(".tt-product-list .tt-product-atc-main").forEach(ele=>{
            ele.removeEventListener("click", this.addToCartEvent),
            ele.addEventListener("click", e=>{
                let that = e.currentTarget;
                this.addToCartEvent(that)
            }
            )
        }
        ),
        document.querySelectorAll(".wishlist-pdp-btn-main .tt-vote-btn-wrap").forEach(ele=>{
            ele.removeEventListener("click", this.voteButtonEvent),
            ele.addEventListener("click", this.voteButtonEvent)
        }
        ),
        document.querySelectorAll(".ttcopybtn").forEach(ele=>{
            ele.removeEventListener("click", this.copyButtonEvent),
            ele.addEventListener("click", this.copyButtonEvent)
        }
        ),
        document.querySelectorAll(".tt-product-list .tt-qty-count").forEach(ele=>{
            ele.removeEventListener("click", this.qtyClickEvent),
            ele.addEventListener("click", this.qtyClickEvent)
        }
        ),
        document.querySelectorAll(".tt-product-list .tt-product-qty").forEach(ele=>{
            ele.removeEventListener("change", this.qtyInputChangeEvent),
            ele.addEventListener("change", e=>{
                let that = e.currentTarget;
                this.qtyInputChangeEvent(that)
            }
            )
        }
        ),
        document.querySelectorAll(".tt-wishlist-details-main .tt-product-content select").forEach(ele=>{
            ele.removeEventListener("change", this.variantChangeEvent),
            ele.addEventListener("change", e=>{
                let that = e.currentTarget;
                this.variantChangeEvent(that)
            }
            )
        }
        )
    }
    ;
    pdpButtonClick = e=>{
        let that = e.currentTarget
          , parent = that.closest(".wishlist-pdp-btn-main")
          , id = parseInt(parent.getAttribute("data-pid"))
          , handle = parent.getAttribute("data-handle")
          , category_enable = this.wishlistMeta.category_enable;
        if (this.customerExist)
            if (that.classList.contains("active"))
                this.deleteProduct(id);
            else if (category_enable) {
                this.categoryPopupShow();
                let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
                popupWrap.setAttribute("data-pid", id),
                popupWrap.setAttribute("data-handle", handle)
            } else
                this.addProductInWithoutCategory(id, handle);
        else
            window.wishlistMetafields.guest_wishlist == 1 ? that.classList.contains("active") ? this.deleteProductLocal(id) : this.addToWishlistLocal(id, handle) : location.href = "/account/login"
    }
    ;
    plpButtonClick = e=>{
        let that = e.currentTarget
          , parent = e;
        that ? parent = that.closest(".tt-wishlist-plp-btn-main") : that = e.querySelector(".wishlist-plp-btn-wrap"),
        parent.classList.contains("tt-cart-btn") && that.querySelectorAll("span")?.forEach(ele=>{
            ele.innerHTML = "Saving..."
        }
        );
        let isCartProduct = !1
          , vId = ""
          , category_enable = this.wishlistMeta.category_enable;
        parent.classList.contains("tt-cart-btn") && (vId = parseInt(parent.getAttribute("data-vid")),
        isCartProduct = !0);
        let id = parseInt(parent.getAttribute("data-pid"))
          , handle = parent.getAttribute("data-handle");
        if (this.customerExist)
            if (!isCartProduct && that.classList.contains("active"))
                this.deleteProduct(id);
            else if (isCartProduct)
                this.addProductInSavedForLater(id, vId, handle);
            else if (category_enable) {
                this.categoryPopupShow();
                let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
                popupWrap.setAttribute("data-pid", id),
                popupWrap.setAttribute("data-handle", handle)
            } else
                this.addProductInWithoutCategory(id, handle);
        else
            window.wishlistMetafields.guest_wishlist == 1 ? !isCartProduct && that.classList.contains("active") ? this.deleteProductLocal(id) : (this.addToWishlistLocal(id, handle),
            isCartProduct && removeFromCartApi(vId)) : location.href = "/account/login"
    }
    ;
    // save for later in main wishlist, please remove this if you not want and change the above function
    addProductInSavedForLater = async(id,vId,handle)=>{
        if (window.getCategoriesData) {
            let data = window.getCategoriesData.data
              , catId = "";
            data.forEach(ele=>{
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
            catId == "" ? (await createCategoryApi("Default Category")).status == 200 && ((await getCategoriesApi())?.data?.forEach(ele=>{
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
            id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)) : id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)
        }
    }
    ;
    addProductInSaved = async(id,vId,handle)=>{
        if (window.getCategoriesData) {
            let data = window.getCategoriesData.data
              , catId = "";
            data.forEach(ele=>{
                ele.category_name == "Save for later" && (catId = ele.category_id)
            }
            ),
            catId == "" ? (await createCategoryApi("Save for later")).status == 200 && ((await getCategoriesApi())?.data?.forEach(ele=>{
                ele.category_name == "Save for later" && (catId = ele.category_id)
            }
            ),
            id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)) : id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)
        }
    }
    ;
    addProductInWithoutCategory = async(id,handle)=>{
        if (window.getCategoriesData) {
            let data = window.getCategoriesData.data
              , catId = "";
            data.forEach(ele=>{
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
            catId == "" ? (await createCategoryApi("Default Category")).status == 200 && ((await getCategoriesApi())?.data?.forEach(ele=>{
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
            id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && (this.categoryPopupShow(!0),
            showToastMsg(handle, !0),
            this.getCategoryAllData(),
            wishlistContent())) : ((await getCategoriesApi())?.data?.forEach(ele=>{
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
            id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && (this.categoryPopupShow(!0),
            showToastMsg(handle, !0),
            this.getCategoryAllData(),
            wishlistContent()))
        }
    }
    ;
    copyButtonEvent = e=>{
        let that = e.target
          , copyUrl = that.closest(".tt-share-input-url").querySelector(".tt-share-input")?.value;
        navigator.clipboard.writeText(copyUrl),
        that.classList.add("active")
    }
    ;
    qtyClickEvent = e=>{
        let that = e.target
          , parent = that.closest(".tt-qty-input")
          , inputEle = parent.querySelector(".tt-product-qty")
          , qtyMin = parseInt(inputEle.getAttribute("min"))
          , actionType = that.getAttribute("data-action")
          , qty = parseInt(inputEle.value);
        actionType == "add" ? (qty += 1,
        qty >= qtyMin + 1 && parent.querySelector(".tt-qty-count--minus").removeAttribute("disabled")) : (qty = qty <= qtyMin ? qtyMin : qty -= 1,
        qty == qtyMin && parent.querySelector(".tt-qty-count--minus").setAttribute("disabled", !0)),
        inputEle.value = qty
    }
    ;
    qtyInputChangeEvent = that=>{
        let minusBtn = that.closest(".tt-qty-input").querySelector(".tt-qty-count--minus")
          , qtyMin = parseInt(that.getAttribute("min"))
          , qty = parseInt(that.value);
        isNaN(qty) || qty <= qtyMin ? (that.value = qtyMin,
        minusBtn.setAttribute("disabled", !0)) : (that.value = qty,
        minusBtn.removeAttribute("disabled"))
    }
    ;
    voteButtonEvent = async e=>{
        if (this.wishlistMeta.vote_btn.enable == 0 || !this.wishlistMeta.vote_btn.enable || !this.customerExist)
            return !1;
        let that = e.currentTarget
          , pId = that.closest(".wishlist-pdp-btn-main").getAttribute("data-pid")
          , flag = !0;
        that.classList.contains("active") && (flag = !1),
        flag && that.classList.add("active"),
        (await submitVoteApi(pId, flag)).status == 200 && this.setupVoteBtn()
    }
    ;
    addProductInCategory = async e=>{
        let that = e.target
          , parent = that.closest(".wishlist-create-category-popup-main")
          , id = parent.getAttribute("data-pid")
          , handle = parent.getAttribute("data-handle")
          , catId = that.getAttribute("cat-id");
        id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && (this.categoryPopupShow(!0),
        showToastMsg(handle, !0),
        this.getCategoryAllData(),
        wishlistContent())
    }
    ;
    detailsPopupCloseEvent = ()=>{
        wishlistPopupOpen(!0)
    }
    ;
    createCategoryEvent = async e=>{
        let catName = e.target.closest(".wishlist-create-category-popup-main").querySelector(".tt-form-new-group input").value;
        catName && (await createCategoryApi(catName)).status == 200 && this.createCategory()
    }
    ;
    wishlistBtnEvent = ()=>{
        let module = wishlistMetafields.button_setting.wishlist_module;
        module == "popup" || module == "drawer" ? document.querySelector(".tt-wishlist-landing-page-main") || (pageCountApi(),
        wishlistPopupOpen()) : location.href = Shopify.locale+"/apps/wishlist/wishlist-landing"
    }
    ;
    tabChangeEvent = e=>{
        let tabId = e.target.getAttribute("data-tab")
          , allTabHead = document.querySelectorAll(".tt-tab-header-wrap li")
          , allTabBody = document.querySelectorAll(".tt-tab-content-wrap .tab-content-inner-wrap");
        allTabHead.forEach(ele=>{
            ele.getAttribute("data-tab") == tabId ? ele.classList.add("active") : ele.classList.remove("active")
        }
        ),
        allTabBody.forEach(ele=>{
            ele.getAttribute("data-tab") == tabId ? ele.classList.add("active") : ele.classList.remove("active")
        }
        )
    }
    ;
    shareButtonEvent = flag=>{
        let popupWrap = document.querySelector(".tt-share-wishlist-popup");
        flag ? (document.body.classList.remove("tt-overflow-hidden"),
        popupWrap.classList.remove("active")) : (document.body.classList.add("tt-overflow-hidden"),
        popupWrap.classList.add("active"))
    }
    ;
    removeCategoryEvent = async e=>{
        let id = e.getAttribute("data-cid");
        (await removeCategoryApi(id)).status == 200 && (this.createCategory(),
        wishlistContent())
    }
    ;
    removeProductEvent = async e=>{
        let id = e.getAttribute("data-id");
        this.customerExist ? (await removeProductApi(id)).status == 200 && (this.createCategory(),
        wishlistContent()) : window.wishlistMetafields.guest_wishlist == 1 && this.deleteProductLocal(id);
        window.wishlistButtonsInit();
    }
    ;
    addToCartEvent = async e=>{
        e.innerHTML = window.adding;
        let parent = e.closest(".tt-product-list")
          , pId = e.getAttribute("data-id")
          , selectedOption = parent.querySelector(".tt-product-content select").selectedOptions[0]
          , availability = selectedOption.getAttribute("data-available")
          , id = parseInt(selectedOption.getAttribute("value"))
          , atcText = window.wishlistMetafields.language2.btn_move_to_cart
          , quantity = parent.querySelector("input[name=tt-quantity]");
        if (quantity = parseInt(quantity.value),
        quantity > 1 || (quantity = 1),
        availability && availability == "true" || availability == !0) {
            let atc = await ajaxAddtocart([{
                id,
                quantity,
                properties: {
                    _is_wishlist_product: !0
                }
            }], !0);
            if (atc.status == 422)
                return parent.querySelector(".tt-error-msg").innerHTML = atc.description,
                e.innerHTML = atcText,
                setTimeout(()=>{
                    parent.querySelector(".tt-error-msg").innerHTML = ""
                }
                , 5e3),
                !1;
            if (cartCountApi(),
            window.wishlistMetafields.remove_product_after_cart == 1)
                if (e.innerHTML = atcText,
                this.customerExist) {
                    if (window.isWishlistSharedPage)
                        return !1;
                    (await removeProductApi(pId)).status == 200 && (wishlistContent(),
                    this.createCategory());
                    var local = '';  
                    if(Shopify.locale != 'en'){
                      local = '/'+Shopify.locale;
                    }  
                    console.log(local);
                    window.wishlistMetafields.stay_on_wishlist_after_cart == 0 && (window.location.href = local+"/cart")
                } else
                    window.wishlistMetafields.guest_wishlist == 1 && (this.deleteProductLocal(pId),
                    wishlistContent());
            else
                e.innerHTML = window.added_cart;
                 var local = '';  
                  if(Shopify.locale != 'en'){
                    local = '/'+Shopify.locale;
                  }  
                window.wishlistMetafields.stay_on_wishlist_after_cart == 0 && (window.location.href = local+"/cart")
        }
    }
    ;
    variantChangeEvent = e=>{
        let parent = e.closest(".tt-product-list")
          , price = e.selectedOptions[0].getAttribute("data-price")
          , priceEle = parent.querySelector(".tt-product-price-wrap");
        var id = e.selectedOptions[0].value;
        
        $(parent).find('.tt-product-content .max_price[data-variant="'+id+'"]').show();
        $(parent).find('.tt-product-content .max_price[data-variant!="'+id+'"]').hide();
        priceEle.innerHTML = formatMoney(price)
    }
    ;
    categoryPopupShow = flag=>{
        let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
        flag ? (document.body.classList.remove("tt-overflow-hidden"),
        popupWrap.classList.remove("active")) : (document.body.classList.add("tt-overflow-hidden"),
        popupWrap.classList.add("active"))
    }
    ;
    getCategoryAllData = async data=>{
        let getCategories = data;
        if (getCategories || (getCategories = await getCategoriesApi()),
        getCategories.status != 200)
            return !1;
        let available_pro = [];
        if (getCategories.data && getCategories.data.length > 0) {
            let pdpButtons = document.querySelectorAll(".wishlist-pdp-btn-main")
              , plpButtons = document.querySelectorAll(".tt-wishlist-plp-btn-main");
            getCategories.data.length > 0 ? (getCategories.data.forEach((item,i)=>{
                available_pro = available_pro.concat(item.product_ids)
            }
            ),
            pdpButtons.length > 0 && pdpButtons.forEach((item,i)=>{
                let item_id = item.getAttribute("data-pid").toString();
                available_pro.includes(item_id) ? item.querySelector(".wishlist-pdp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active")
            }
            ),
            plpButtons.length > 0 && plpButtons.forEach((item,i)=>{
                let item_id = item.getAttribute("data-pid").toString();
                available_pro.includes(item_id) ? item.querySelector(".wishlist-plp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
            }
            )) : (pdpButtons.length > 0 && pdpButtons.forEach((item,i)=>{
                item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active")
            }
            ),
            plpButtons.length > 0 && plpButtons.forEach((item,i)=>{
                item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
            }
            ))
        }
    }
    ;
    fetchProductExistLocal = ()=>{
        let productsData = techno_getCookie("wishlist")
          , flag = !1
          , curr_pro_id = []
          , allpro = document.querySelectorAll(".wishlist-pdp-btn-main")
          , plpButtons = document.querySelectorAll(".tt-wishlist-plp-btn-main");
        productsData && (productsData = JSON.parse(productsData),
        productsData.forEach(item=>{
            curr_pro_id.push(item.p_id)
        }
        )),
        allpro.length > 0 && allpro.forEach((item,i)=>{
            let item_id = parseInt(item.getAttribute("data-pid"));
            curr_pro_id.includes(item_id) ? (item.querySelector(".wishlist-pdp-btn-wrap")?.classList.add("active"),
            flag = !0) : item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active")
        }
        ),
        plpButtons.length > 0 && plpButtons.forEach((item,i)=>{
            let item_id = parseInt(item.getAttribute("data-pid"));
            curr_pro_id.includes(item_id) ? item.querySelector(".wishlist-plp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
        }
        )
    }
    ;
    addToWishlistLocal = (p_id,p_handle)=>{
        let productsData = techno_getCookie("wishlist");
        productsData == 0 ? productsData = [] : productsData = JSON.parse(productsData);
        let obj = {
            p_id,
            p_handle
        };
        productsData.push(obj),
        productsData = JSON.stringify(productsData),
        setCookie("wishlist", productsData, 100),
        showToastMsg(p_handle, !0),
        this.fetchProductExistLocal(),
        wishlistContent()
    }
    ;
    deleteProduct = async id=>{
        id && (await removeProductApi(id)).status == 200 && (this.getCategoryAllData(),
        wishlistContent())
    }
    ;
    deleteProductLocal = id=>{
        let productsData = techno_getCookie("wishlist");
        if (productsData != 0) {
            productsData = JSON.parse(productsData);
            let newProductData = productsData.filter(item=>{
                let flag = !0;
                return item.p_id == id && (flag = !1),
                flag
            }
            );
            newProductData = JSON.stringify(newProductData),
            setCookie("wishlist", "", 0),
            setCookie("wishlist", newProductData, 100),
            this.fetchProductExistLocal(),
            wishlistContent()
        }
    }
    ;
    setButtons = ()=>{
        if (window.isWishlistSharedPage)
            return !1;
        let allPlaceParent = document.querySelectorAll(".wishlist-pdp-btn-main")
          , button_style = this.wishlistMeta.button_style
          , buttonSty = button_style.btnStyle
          , buttonStyleClass = getMainButtonClass(buttonSty)
          , buttonText = window.add_to_cart
          , buttonAfterText = window.added_to_cart
          , buttonColor = button_style.btnColor
          , buttonBg = button_style.btnBgColor
          , buttonAfterColor = button_style.btnColorAfterWishlist
          , buttonAfterBg = button_style.btnBgColorAfterWishlist;
        if (allPlaceParent.forEach(ele=>{
            ele.classList.add(buttonStyleClass),
            ele.setAttribute("style", `--tt-main-btn-color:${buttonColor}; --tt-main-btn-bg:${buttonBg}; --tt-main-af-btn-color:${buttonAfterColor}; --tt-main-af-btn-bg:${buttonAfterBg};`);
            let islikeButton = !1
              , voteBtn = "";
            this.customerExist && (this.wishlistMeta.vote_btn.enable == 1 || this.wishlistMeta.vote_btn.enable) && (islikeButton = !0,
            voteBtn = `
                    <button type="button" class="tt-vote-btn-wrap">
                        <span class="tt-vote-btn-span tt-vote-init-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeEmptyIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                        <span class="tt-vote-btn-span tt-vote-after-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeFillIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                    </button>
                `);
            let buttonHtml = `
                <div class="wishlist-pdp-btn-main-wrap">
                    <button type="button" class="wishlist-pdp-btn-wrap ${islikeButton ? "" : "full-width"}">
                        <span class="wishlist-btn-content-span wishlist-init-label">
                            <span class="wishlist-icon">
                                ${wishlistEmptyIcon}
                            </span>
                            <span class="tt-btn-text">${buttonText}</span>
                        </span>
                        <span class="wishlist-btn-content-span wishlist-after-label">
                            <span class="wishlist-icon">
                                ${wishlistFillIcon}
                            </span>
                            <span class="tt-btn-text">${buttonAfterText}</span>
                        </span>
                    </button>
                    ${voteBtn}
                </div>
            `;
            ele.innerHTML = buttonHtml
        }
        ),
        this.wishlistMeta.button_setting.launch_btn_type == "floating_btn") {
            let floatingButton = document.createElement("DIV")
              , buttonClass2 = this.wishlistMeta.button_setting.launch_btn_placement
              , buttonStyle = this.wishlistMeta.button_setting.launch_btn_style
              , buttonRadius = this.wishlistMeta.button_setting.launch_btn_radius
              , buttonColor2 = this.wishlistMeta.button_setting.launch_btn_text_color
              , buttonBg2 = this.wishlistMeta.button_setting.launch_btn_bg_color
              , buttonText2 = this.wishlistMeta.button_setting.launch_btn_text;
            floatingButton.setAttribute("class", `wishlist-floating-btn-main ${buttonClass2} ${buttonStyle} ${buttonRadius}`),
            floatingButton.setAttribute("style", `--floating-btn-color:${buttonColor2}; --floating-btn-bg:${buttonBg2}`);
            let buttonHtml = `
                <button type="button" class="wishlist-floting-btn-wrap">
                    <span class="wishlist-icon">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-text">${buttonText2}</span>
                </button>
                `;
            floatingButton.innerHTML = buttonHtml,
            document.body.append(floatingButton)
        }
        this.customerExist && (this.wishlistMeta.vote_btn.enable == 1 || this.wishlistMeta.vote_btn.enable) && this.setupVoteBtn();
        let plpBtnWrap = document.querySelectorAll(".tt-wishlist-plp-btn-main")
          , collectionStyle = window.wishlistMetafields.collection
          , buttonClass = collectionStyle.icon_position
          , plpButtonColor = collectionStyle.icon_before_wishlist_color
          , plpButtonBg = collectionStyle.icon_after_wishlist_color;
        plpBtnWrap.forEach(ele=>{
            if (this.wishlistMeta.save_for_later == 0 && ele.classList.contains("tt-cart-btn"))
                return !1;
            ele.setAttribute("style", `--wishlist-plp-btn-color:${plpButtonColor}; --wishlist-plp-btn-bg:${plpButtonBg}`),
            ele.classList.add("tt-position", buttonClass);
            let buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button" title="${window.wishlist_tooltip}">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        ${wishlistFillIcon}
                    </span>
                </button>
            `;
            this.wishlistMeta.save_for_later == 1 && ele.classList.contains("tt-cart-btn") && (buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button" title="${window.wishlist_tooltip}">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        Save for later
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        Save for later
                    </span>
                </button>
            `),
            ele.innerHTML = buttonHtml
        }
        )
    }
    ;
    createCategory = async()=>{
        let getCategories = await getCategoriesApi()
          , currentCategoryHtml = "";
        getCategories && getCategories.data && getCategories.data.length > 0 && getCategories.data.forEach(ele=>{
            currentCategoryHtml += `
                    <div class="tt-form-group">
                        <span class="wishlist-p-tag">${ele.category_name}</span>
                        <button type="button" class="tt-btn tt-add-wishlist" cat-id="${ele.category_id}">Add</button>
                    </div>
                `
        }
        );
        let categoryHtml = `
            <div class="wishlist-create-category-popup">
                <div class="tt-popup-overlay"></div>
                <div class="tt-category-popup">
                    <div class="tt-category-close">${wishlistPopupCloseIcon}</div>
                    <div class="tt-popup-content">
                        <div class="tt-wishlist-form">
                            <div class="tt-form-title">
                                    <p class="wishlist-p-tag">Add this item to a category</p>
                            </div>
                            <div class="tt-cat-wrap">
                                ${currentCategoryHtml}
                            </div>
                            <div class="tt-form-new-group">
                                <input type="text" name="wishlistname" placeholder="Create New Category">
                                <button type="button" class="tt-btn tt-add-wishlist">Create Category</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        `
          , divEle = document.createElement("DIV");
        divEle.setAttribute("class", "wishlist-create-category-popup-main"),
        document.querySelector(".wishlist-create-category-popup-main") ? document.querySelector(".wishlist-create-category-popup-main").innerHTML = categoryHtml : (divEle.innerHTML = categoryHtml,
        document.body.append(divEle)),
        this.clickEvents(),
        this.getCategoryAllData(getCategories)
    }
    ;
    setupVoteBtn = async()=>{
        let wishlistMainBtn = document.querySelectorAll(".wishlist-pdp-btn-main");
        if (wishlistMainBtn.length > 0) {
            let pId = wishlistMainBtn[0].getAttribute("data-pid")
              , voteCustomerData = await getCustomerVoteDataApi(pId);
            if (voteCustomerData.status == 200) {
                let voteBtnStyle = this.wishlistMeta.vote_btn
                  , buttonColor = voteBtnStyle.btn_color
                  , buttonBg = voteBtnStyle.btn_bg
                  , buttonAfterColor = voteBtnStyle.after_btn_color
                  , buttonAfterBg = voteBtnStyle.after_btn_bg;
                wishlistMainBtn.forEach(ele=>{
                    let voteBtn = ele.querySelector(".tt-vote-btn-wrap");
                    voteBtn.setAttribute("style", `--tt-vote-btn-color:${buttonColor}; --tt-vote-btn-bg:${buttonBg}; --tt-vote-af-btn-color:${buttonAfterColor}; --tt-vote-af-btn-bg:${buttonAfterBg};`),
                    voteBtn.querySelectorAll(".tt-vote-count").forEach(innerEle=>{
                        innerEle.innerHTML = voteCustomerData.data
                    }
                    ),
                    voteCustomerData.customerVote == 1 ? voteBtn.classList.add("active") : voteBtn.classList.remove("active")
                }
                )
            }
        }
    }
    ;
    settingsBasedContent = ()=>{
        let pageTitle =  window.page_title
          , isEle = document.querySelector(window.wishlistPageSelector)
          , mainEle = document.querySelector(".tt-wishlist-details-main");
        if (isEle || (isEle = document.querySelector(window.wishlistSharedPageSelector),
        isEle && (window.isWishlistSharedPage = !0)),
        pageTitle && (document.querySelector(".tt-details-title p").innerHTML = pageTitle),
        isEle && (pageCountApi(),
        isEle.append(mainEle)),
        window.isWishlistSharedPage)
            return !1;
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        if (window.wishlistMetafields.share_wishlist == 1 && window.customerExist) {
            let shareData = window.wishlistMetafields.share_wishlist_data
              , sharePopup = document.querySelector(".tt-share-wishlist-popup");
            shareButton.classList.remove("tt-hide"),
            document.body.append(sharePopup),
            shareData.facebook == 0 && sharePopup.querySelector(".tt-fb-share").classList.add("tt-hide"),
            shareData.twitter == 0 && sharePopup.querySelector(".tt-twitter-share").classList.add("tt-hide"),
            shareData.whatsapp == 0 && sharePopup.querySelector(".tt-wp-share").classList.add("tt-hide"),
            shareData.email == 0 && sharePopup.querySelector(".tt-email-share").classList.add("tt-hide"),
            shareData.copy_link == 0 && sharePopup.querySelector(".tt-share-copy").classList.add("tt-hide")
        }
    }
    ;
    trendingWishlistSetup = async()=>{
        let selector = document.querySelectorAll(".super-wishlist-trending-widget");
        if (this.wishlistMeta.show_trending_wishlist == 0 || selector.length == 0)
            return !1;
        let trendingData = await trendingApi();
        if (trendingData.status == 200 && trendingData.data && trendingData.data.length > 0) {
            let trendingSettings = this.wishlistMeta.trending
              , trending_layout = trendingSettings.trending_layout
              , trending_title = trendingSettings.trending_title
              , trending_desktop_per_row = trendingSettings.trending_desktop_per_row
              , trending_mobile_per_row = trendingSettings.trending_mobile_per_row
              , trending_slider_arrows = trendingSettings.trending_slider_arrows
              , trending_slider_auto_rotate = trendingSettings.trending_slider_auto_rotate
              , productsHtml = "";
            trendingData.data.forEach(ele=>{
                productsHtml += `
                    <div class="tt-product-list swiper-slide" data-handle="${ele.handle}">
                    </div>
                `
            }
            );
            let trendingHtml = `
                <div class="tt-container">
                    <div class="tt-wishlist-trending-wrap">
                        <div class="tt-trending-title-wrap">
                            <p>${trending_title}</p>
                        </div>
                        <div class="tt-wishlist-trending-inner-wrap swiper">
                            <div class="swiper-wrapper">
                                ${productsHtml}
                            </div>
                            <div class="swiper-button swiper-button-next">
                            </div>
                            <div class="swiper-button swiper-button-prev">
                            </div>
                        </div>
                    </div>
                </div>
            `;
            selector.forEach(ele=>{
                ele.classList.add(trending_layout),
                ele.setAttribute("data-desktop-row", trending_desktop_per_row),
                ele.setAttribute("data-mobile-row", trending_mobile_per_row),
                ele.setAttribute("data-arrow", trending_slider_arrows),
                ele.setAttribute("data-auto-rotate", trending_slider_auto_rotate),
                trending_layout == "slider" ? ele.setAttribute("style", "--tt-wishlist-font-multipler:1;opacity:0") : ele.setAttribute("style", "--tt-wishlist-font-multipler:1"),
                ele.innerHTML = trendingHtml
            }
            ),
            trending_layout == "slider" ? updateProductContent(!0, !0) : updateProductContent(!1, !0)
        }
    }
    ;
    init = ()=>{
        if (window.wishlistMetafields?.trending?.trending_layout == "slider") {
            let cssLink = document.createElement("link");
            cssLink.rel = "stylesheet",
            cssLink.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css",
            document.head.appendChild(cssLink);
            let jsScript = document.createElement("script");
            jsScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
            document.body.appendChild(jsScript)
        }
        this.setButtons(),
        window.ttWishlistClickEvents = ()=>{
            this.clickEvents()
        }
        ,
        this.customerExist ? this.createCategory() : window.wishlistMetafields.guest_wishlist == 1 ? (this.fetchProductExistLocal(),
        this.clickEvents()) : this.clickEvents(),
        this.settingsBasedContent(),
        wishlistContent()
    }
    ;
    reButtonsInit = ()=>{
        this.setButtons(),
        this.customerExist ? this.createCategory() : window.wishlistMetafields.guest_wishlist == 1 && this.fetchProductExistLocal(),
        this.settingsBasedContent(),
        wishlistContent()
    }
}
let wishlistData = new WishlistPDP;
window.wishlistInit = ()=>{
    wishlistData.init()
}
,
window.wishlistButtonsInit = ()=>{
    wishlistData.reButtonsInit()
};

$(document).on('click','.tt-product-content .grid-product__colors .color-swatch',function(e) {
   var url = $(this).attr('data-url');
   window.location.href = url; 
})

$(window).on('resize',function(e) {
   setTimeout(function(e) {
       
      var newheight = 0;
      $('.new_min_height').css('height','');
      $('.new_min_height').each(function(e) {
          if(newheight < $(this).innerHeight()){
              newheight = $(this).innerHeight();
          } 
      })
      $('.new_min_height').css('height',newheight+'px');
      
     
      var height = 0;
      $('.tt-product-content').css('height','');
      $('.tt-product-content').each(function(e) {
          if(height < $(this).innerHeight()){
              height = $(this).innerHeight();
          } 
      })
      $('.tt-product-content').css('height',height+'px');
      
    },500);
})